<!-- 自动续费 -->
<template>
  <div class='vipRenew'>
    <publicHeader :pageTitle="pageTitle" isWhite='true' v-if="!noHeader"></publicHeader>
    <div class="zhanwei" v-if="!noHeader">

    </div>
    <div class="autoRenewBox">
      <!-- 个人信息 -->
      <div class="userInfo">
        <div class="userHeadImg">
          <img :src="userInfo.userHeadImg" alt="">
        </div>
        <div class="otherInfo">
          <div class="userName">
            {{userInfo.userName}}
          </div>
          <div class="word" v-if="isAuto">
            已开通{{vipInfo.vipName}}自动续费
          </div>
          <div class="word" v-else>
            您未开通{{vipInfo.vipName}}自动续费服务
          </div>
        </div>
      </div>
      <!-- 延期框 -->
      <div class="whiteBox">
        <div class="word">苹果设备会员到账可能会有延期，感谢您的谅解！</div>
        <div class="serve" v-if="!isAuto">自动续费服务</div>
        <!-- 关闭自动续费的内容 -->
        <div class="autoInfo" v-else>
          <div class="vipName">{{vipInfo.vipName}}</div>
          <div class="time">有效期：{{contractInfo.deadlineTime}}</div>
          <div class="payType" v-if="platForm===2">苹果支付</div>
          <div class="payType" v-else>微信支付</div>
          <div class="nextInfo">
            <div class="next first">
              <div class="word">下次续费时间</div>
              <div class="infos">{{contractInfo.nextFeeTime}}</div>
            </div>
            <div class="next">
              <div class="word">每次续费金额</div>
              <div class="infos">{{contractInfo.nextFee}}元 （原价{{contractInfo.money}}元）</div>
            </div>
          </div>

          <div class="tips" v-if="platForm===2">每月由苹果公司扣费，扣费成功后，会员有效期增加30天</div>
          <div class="tips" v-else>每月由微信扣费，扣费成功后，会员有效期增加30天。</div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="opbtn" v-if="!isAuto" @click="handleOpenRenewBtn">
        开启自动续费
      </div>
      <div class="opbtn clbtn" @click="handleCloseRenewBtn" v-else>
        关闭自动续费
      </div>
      <!-- 说明 -->
      <div class="info">
        <div class="title">
          中国体育自动续费服务说明
        </div>
        <div class="desc" v-if="isIOS">
          1. 付款：用户确认购买并付款后计入iTunes账户；<br>
          2. 取消续订：如需取消续订，请在当前订阅周期到期前24小时以内，手动在iTunes/Apple ID 设置管理中关闭自动续费功能，到期前24小时内取消，将会收取订阅费用；<br>
          3. 续费：苹果iTunes账户会在到期前24小时内扣费，扣费成功后订阅周期顺延一个订阅周期。<br>
        </div>
        <div class="desc" v-else>
          1、自动续费服务可随时订阅随时取消<br>
          2、取消续订：如需取消续订，请在到期前24小时时，手动在微信-我的-支付-右上角（更多）-支付管理-自动扣费-取消，取消后不再扣费<br>
          3、续费：您的会员到期前24小时，微信会自动从您的微信账号中扣费，扣费成功后有效期顺延一个月。
        </div>
      </div>
      <!-- 底部条款/协议 -->
      <div class="agree">
        <div class="agreeItem" @click="gotoPrivacy">
          隐私条款
        </div>
        <div class="agreeItem" @click="gotoAgreement">
          自动续费服务协议
        </div>
      </div>
      <!-- loading -->
      <div class="loading" v-if="isLoading">
        <img src="https://images.zhibo.tv/2021/0308/icon_loading@10x.png" alt="">
      </div>
      <!-- 提示弹框 -->
      <publicDialog :height="height" :info="info" :title="title" :btn1="btn1" :btn2="btn2" :platForm="platForm" @changeShow='showDialog' :dialogIsShow='dialogIsShow' v-show='dialogIsShow'
        @closeRenew="closeRenew(userInfo.vipType)" @getAutoStatus="getAutoStatus"></publicDialog>
    </div>
  </div>
</template>

<script>
import publicDialog from '../components/PublicDialog'
import publicHeader from '../components/PublicHeader'
export default {
  components: {
    publicDialog, publicHeader
  },
  data () {
    return {
      // 手机系统
      isIOS: false,
      id: '',
      bt: 2,
      pId: '',
      isAuto: 0,
      pt: 5, //微信
      productId: '',// ios产品id
      // 用户信息
      userInfo: {},
      // 会员信息
      vipInfo: {
        vipName: ''
      },
      // 签约信息
      contractInfo: {

      },
      // dialog的提示内容
      dialogIsShow: false,
      info: '',
      title: "提示",
      btn1: "",
      btn2: '',
      height: '',
      // 开通成功
      openSuccess: false,
      platForm: '',
      pageTitle: '',
      token: '',
      code: '',
      isLoading: false
    }
  },
  created () {
    this.noHeader = this.$route.query.noHeader
    console.log(this.noHeader);
    this.getToken()
    this.id = this.$route.query.id
    this.isIOS = this.$CONFIG.isIOS
    document.title = "自动续费管理"
    this.pageTitle = "自动续费管理"
    this.changeAppTitle('自动续费管理')
    this.checkAutoStatus()
  },
  mounted () {
    window.VIP_CENTER = {
      paySucc: () => {
        this.btn1 = ''
        this.btn2 = '我知道了'
        this.info = `您已成功开通${this.vipInfo.vipName}自动续费`
        this.paySuccess = true
        this.showDialog(true)
      }
    }
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 跳转两端新容器
    jumpweb (url) {
      console.log(url);
      var androidParam = '{"url":"' + url + '"}';
      var iosParam = {
        "url": url
      };
      try {
        window.webkit.messageHandlers.jumpWeb.postMessage(iosParam);
      } catch (e) {
        console.log('ios打开新页面失败');
      }

      try {
        window.LiveAppJS.jumpWeb(androidParam);
      } catch (e) {
        console.log('安卓打开新页面失败');
      }
    },
    // 安卓自动续费(自动续费页面不使用此方法)
    openAndroidAuto () {
      let params = {
        token: this.token,
        pId: this.pId,
        bt: this.bt,
        pt: this.pt,
        vId: this.id
      }
      let res = this.$vipapi.openAndroidAuto(params)
      console.log(res);
    },
    // 安卓自动续费（本页面使用此方法）
    async openAndroiidAutoInAuto () {
      // let params = {
      //   token: this.token,
      //   pId: this.pId,
      //   bt: this.bt,
      //   pt: this.pt,
      //   vId: this.id,
      //   statistics: this.$CONFIG.statistics
      // }
      let params = `token=${this.token}&pId=${this.pId}&bt=${this.bt}&pt=5&vId=${this.id}&statistics=${this.$CONFIG.statistics}`
      let res = await this.$vipapi.openAndroiidAutoInAuto(params)
      this.code = JSON.parse(res.data.data).contract_code
      console.log(res);
      if (res.data.status === '200') {
        // 可以开启自动续费
        console.log(res.data.data);
        try {
          window.LiveAppJS.wxEntrustInfo(res.data.data);
        } catch (error) {
          console.log(error);
        }
        this.height = '4.16rem'
        this.info = '请确认支付是否已完成，如果在支付过程中遇到问题请点击"重新支付"，如果已经成功支付请点击"已支付"'
        this.btn1 = "重新支付"
        this.btn2 = '已支付'
        setTimeout(() => {
          this.showDialog(true)
        }, 1000);
      } else {
        this.btn1 = ''
        this.btn2 = '我知道了'
        this.info = res.data.data
        this.showDialog(true)
      }

    },
    // // 苹果支付
    // async gotoIOSPay () {
    //   let params = {
    //     token: this.token,
    //     productId: this.productId,
    //     bagType: 2,
    //   }
    //   let res = await this.$vipapi.IOSPay(params)
    //   console.log(res);
    //   this.btn1 = ''
    //   this.btn2 = '我知道了'
    //   this.info = res.data.data
    //   this.showDialog(true)
    // },
    // 查看自动续费开通状态
    async checkAutoStatus () {
      let params = {
        token: this.token,
        vid: this.id,
        statistics: this.$CONFIG.statistics
      }
      let res = await this.$vipapi.checkAutoStatus(params)
      console.log(res);
      this.isAuto = res.data.data.contractStatus
      this.productId = res.data.data.info.vipInfo.productId
      this.userInfo = res.data.data.info.userInfo
      this.vipInfo = res.data.data.info.vipInfo
      this.pId = this.vipInfo.priceId
      this.contractInfo = res.data.data.info.contractInfo
      this.platForm = res.data.data.info.contractInfo.platForm
    },
    // 开通按钮的点击事件
    handleOpenRenewBtn () {
      if (!this.isIOS) {
        //安卓
        console.log('安卓');
        this.openAndroiidAutoInAuto()
      } else {
        // 苹果
        console.log('苹果');
        this.gotoIOSPay()
        // 直接将产品id传给ios原生方法
      }
    },
    // 苹果支付开通自动续费
    async gotoIOSPay () {
      try {
        window.webkit.messageHandlers.paymentWithProduct.postMessage({ 'productId': this.productId });
        return;
      } catch (error) {
        console.log('ios autopay error', this.productId)
      }
    },
    // 关闭按钮的点击事件
    handleCloseRenewBtn () {
      this.height = '3.74rem'
      this.info = '关闭自动续费后,当会员到期时不再自动扣费,同时您也无法享受会员权益'
      this.btn1 = '确认关闭'
      this.btn2 = '再看看'
      this.showDialog(true)
    },
    // 展示提示弹窗
    showDialog (visible) {
      this.dialogIsShow = visible
    },
    // 关闭自动续费（调接口）
    async closeRenew () {
      let params = `token=${this.token}&code=${this.contractInfo.code}&bt=${this.bt}`
      let res = await this.$vipapi.closeAutoStatus(params)
      console.log(res);
      // status -1 当前协议不存在
      // if (res.data.status === '-1') {
      //   this.info = res.data.data
      // }
      // if (res.data.status == '200') {
      this.btn1 = ''
      this.btn2 = '我知道了'
      this.info = res.data.data
      this.showDialog(true)
      // }
    },
    // 跳转自动续费服务协议
    gotoAgreement () {
      // window.open('http://vip.zhibo.tv/vip/auto-pay-declare')
      let url = 'http://vip.zhibo.tv/vip/auto-pay-declare'
      this.jumpweb(url)
    },
    // 跳转隐私条款
    gotoPrivacy () {
      // window.open('http://static.zhibo.tv/agreement/privacy_agreement.html')
      let url = 'http://static.zhibo.tv/agreement/privacy_agreement.html'
      this.jumpweb(url)
    },
    getAutoStatus () {
      this.isLoading = true
      this.payDialogShow = false
      this.autoTimer1 = setInterval(() => {
        this.getStatusByInterface()
      }, 1000);
      this.autoTimer2 = setTimeout(() => {
        clearInterval(this.autoTimer1)
        this.isLoading = false

        // 未签约未支付
        if (this.autopayStatus === 0) {
          console.log('未支付');
          clearInterval(this.autoTimer1)
          this.isLoading = false
          this.height = '4rem'
          this.info = `暂未查询到您的支付结果，可能是会员延时到账，如有疑问，请联系客服，客服电话：400-801-5553`
          this.btn1 = ""
          this.btn2 = '我知道了'
          this.showDialog(true)
        }
        // 已签约未支付
        if (this.autopayStatus === 1) {
          console.log('已签约未支付');
          clearInterval(this.autoTimer1)
          this.isLoading = false
          this.height = '4rem'
          this.info = `暂未查询到您的支付结果，可能是会员延时到账，如有疑问，请联系客服，客服电话：400-801-5553`
          this.btn1 = ""
          this.btn2 = '我知道了'
          this.showDialog(true)
        }
      }, 5000);
      // // 支付失败
      // if (this.autopayStatus===0) {
      //   console.log('支付失败');
      //   this.height = '3.32rem'
      //   this.info = '您已开通连续包月失败'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
      // // 支付中
      // if (this.autopayStatus===1) {
      //   console.log('支付中');
      //   this.height = '3.32rem'
      //   this.info = '支付中,请稍后...'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
      // // 支付成功
      // if (this.autopayStatus===2) {
      //   console.log('支付成功');
      //   clearInterval(this.autoTimer)
      //   this.height = '3.32rem'
      //   this.info = '您已开通连续包月成功'
      //   this.btn1 = ""
      //   this.btn2 = '我知道了'
      //   this.showDialog(true)
      // }
    },
    async getStatusByInterface () {
      let params = {
        token: this.token,
        contractCode: this.code
      }
      let res = await this.$vipapi.getAutoStatus(params)
      this.autopayStatus = Number(res.data.data.payState)

      console.log(this.autopayStatus);
      // 支付成功
      if (this.autopayStatus === 2) {
        let nextTime = res.data.data.nextFeeTime
        console.log('支付成功');
        clearInterval(this.autoTimer1)
        this.isLoading = false
        this.height = '4rem'
        this.info = `您已开通${this.vipInfo.vipName}连续包月，下次扣费时间为：${nextTime}，扣费后会员有效期将延长30天!`
        this.btn1 = ""
        this.btn2 = '我知道了'
        this.showDialog(true)
      }
    },
    // 修改两端标题
    changeAppTitle (newtitle) {
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(newtitle)
      } catch (e) {
        console.log('IOS修改标题', newtitle)
      }
      try {
        window.LiveAppJS.changeTitle(newtitle)
      } catch (e) {
        console.log("安卓修改标题", newtitle)
      }
    }
  },
}
</script>
<style lang='less' scoped>
body {
  background: #f2f2f2;
}
.vipRenew {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  background: #f2f2f2;
  .autoRenewBox {
    padding: 0.3rem 0.3rem 0.2rem 0.3rem;
    // 个人信息
    .userInfo {
      display: flex;
      // padding-top: 0.3rem;
      .userHeadImg {
        margin-right: 0.2rem;

        img {
          display: block;
          width: 1rem;
          height: 1rem;
          background: url('https://t100-file.zhibo.tv/uploads/new_upload/image/20200612/20200612110016_94956.png')
            #393939 no-repeat center;
          background-size: 60%;
          border: 0.02rem solid #ffffff;
          border-radius: 50%;
        }
      }

      .otherInfo {
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        align-items: flex-start;
        margin: 0.08rem 0;

        .userName {
          margin-bottom: 0.15rem;
          font-size: 0.32rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: bold;
          color: #1b1a1f;
          // background: crimson;
        }

        .word {
          //  background: crimson;
          font-size: 0.26rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    // 延期框
    .whiteBox {
      width: 100%;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 0.1rem;
      margin: 0.3rem 0;
      padding: 0.3rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .word {
        margin-bottom: 0.2rem;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .serve {
        font-size: 0.26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .autoInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        // align-items: flex-start;
        // 会员名称
        .vipName {
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1b1a1f;
        }

        // 有效期
        .time {
          margin-top: 0.1rem;
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        // 支付方式
        .payType {
          margin: 0.2rem 0;
          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1b1a1f;
        }

        // 下一次扣费信息
        .nextInfo {
          padding: 0.2rem 0;
          border-top: 0.01rem solid #e5e5e5;
          border-bottom: 0.01rem solid #e5e5e5;

          .next {
            display: flex;
            justify-content: space-between;
            font-size: 0.28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;

            .word {
              color: #666666;
            }

            .infos {
              color: #333333;
            }
          }

          .first {
            margin-bottom: 0.2rem;
          }
        }

        // 提示
        .tips {
          margin-top: 0.2rem;
          font-size: 0.26rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    // 按钮
    // 开通
    .opbtn {
      width: 100%;
      height: 0.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #613f25;

      background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
      border-radius: 0.45rem;
    }

    // 关闭
    .clbtn {
      background: #ffffff;
      color: #613f25;
    }

    // 服务说明
    .info {
      margin-top: 0.4rem;

      .title {
        margin-bottom: 0.1rem;
        text-align: left;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .desc {
        text-align: left;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 0.44rem;
      }
    }

    // 底部条款/协议
    .agree {
      // padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
      // padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
      // position: fixed;
      // bottom: 0.2rem;
      // left: 0;
      // width: calc(100% - 0.6rem);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.4rem;

      .agreeItem {
        width: 3.35rem;
        height: 0.6rem;
        background: #f7f7f7;
        border-radius: 0.06rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }
  }
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      display: block;
      width: 0.88rem;
      height: 0.88rem;
      animation: rotate 2s linear infinite;
      z-index: 2;
    }
    @keyframes rotate {
      0% {
        transform: rotateZ(0deg); /*从0度开始*/
      }
      100% {
        transform: rotateZ(360deg); /*360度结束*/
      }
    }
  }
}
</style>